import React from 'react';
import './ratecard.css';
import Navbar from '../../components/Navbar';
import Footer from "../../components/Footer";
import TawkTo from "../../components/TawkTo";


function RateCard() {
    return (
        <>
            <Navbar />
            <TawkTo />
            <div className="ratecard-container">
                <h1>Exclusive Rate Card</h1>
                <p>
                    Indulge in the ultimate experience, where passion, connection, and satisfaction are guaranteed. My rates reflect the quality of attention, intimacy, and care that you deserve.
                </p>

                <section>
                    <h2>Signature Full Satisfactory Girlfriend Experience (GFE)</h2>
                    <ul>
                        <li>A deeply relaxing Massage to soothe your body and awaken your senses.</li>
                        <li>An intimate, uninhibited Bareback Blowjob for raw, electrifying connection.</li>
                        <li>The option for Greek, an adventurous and sensual exploration.</li>
                        <li>Multiple Shots of Orgasm, ensuring your satisfaction is truly limitless.</li>
                    </ul>
                </section>

                <section>
                    <h2>Rates for Your Perfect Experience</h2>
                    <ul>
                        <li>
                            <strong>30–60 Minutes: $300.00</strong>
                            A short but unforgettable escape. Whether you seek a moment of relaxation, a burst of passion, or both, this time is yours to indulge and enjoy.
                        </li>
                        <li>
                            <strong>2–3 Hours: $500.00</strong>
                            A more extended rendezvous for those who desire deeper connection and more time to savor every moment. Perfect for letting inhibitions fall away and fully embracing the experience.
                        </li>
                        <li>
                            <strong>Overnight (8 Hours): $1,000.00</strong>
                            A night of uninterrupted passion and intimacy. Share an evening where pleasure is the only priority, and wake up to the lingering warmth of satisfaction.
                        </li>
                    </ul>
                </section>

                <section>
                    <h2>Additional Information</h2>
                    <ul>
                        <li><strong>Outcalls:</strong> Add an extra $100.00 for the convenience of having me join you in your preferred location, whether it’s your home or a luxurious hotel suite.</li>
                        <li><strong>Discretion and Privacy:</strong> I value and uphold complete confidentiality to ensure your comfort and peace of mind.</li>
                        <li><strong>Personalized Experiences:</strong> If you have specific requests or longer engagements in mind, we can tailor our time together to create your ultimate fantasy. Please inquire for custom arrangements.</li>
                    </ul>
                </section>

                <section>
                    <h2>Booking Etiquette</h2>
                    <ul>
                        <li>Advanced booking is highly recommended for optimal planning and privacy.</li>
                        <li>Be respectful and transparent in your communication; I am here to make your dreams a reality.</li>
                    </ul>
                </section>

                <section>
                    <h2>Let’s Create Something Unforgettable</h2>
                    <p>
                        Your pleasure is my priority, and I am here to provide an experience that exceeds your expectations. Whether it’s a brief escape or an indulgent night, I promise to leave you completely satisfied and yearning for more.
                    </p>
                    <p>
                        Why wait? Let’s turn your fantasies into unforgettable moments right now.
                    </p>
                </section>
            </div>
            <Footer />
        </>
    );
}

export default RateCard;
